import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserPrefsService } from '../../../core/services/user-prefs.service';

@Component({
  selector: 'app-buttons',
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './buttons.component.html',
  styleUrl: './buttons.component.css',
})
export class ButtonsComponent {
  @Input() btnFields: any;
  @Input() fields: any;
  @Input() isLoading: any;
  @Input() isButtonShow: any;
  @Input() disabledBtn: any;
  @Input() isDisabled: any;
  @Input() formData: any;
  @Output() buttonClick = new EventEmitter<void>();
  constructor(private prefs: UserPrefsService) {}
  onClick(btn: any) {
    this.buttonClick.emit(btn);
  }

  isNonSubmitAction(btn: any): boolean {
    // If clickAction is NOT present, this is a submit button
    if (!btn || !btn.clickAction) {
      return false;
    }
    const nonSubmitActions = [
      'modalClose',
      'closeModal',
      'cancel',
      'goToPreviousStep',
      'navigate',
      'back',
      'clearAll',
      'clearButton',
      'delete',
    ];

    // Special handling for goToNextStep
    if (btn.clickAction === 'goToNextStep') {
      return btn.componentId !== 'nextButton';
    }

    return nonSubmitActions.includes(btn.clickAction);
  }

  isButtonPosition(btn: any, position: any): boolean {
    const btnPosition = btn?.style?.position || 'end';
    return btnPosition === position;
  }

  isDarkMode(): boolean {
    return this.prefs.resolvedTheme() === 'dark';
  }

  getButtonStyles(btn: any): { [key: string]: string } {
    const isPrimary =
      btn.componentId === 'applyButton' ||
      btn.componentId === 'nextButton' ||
      btn.fieldType === 'deleteButton' ||
      btn.componentId === 'center-actionButton';
    let bgColor = btn.style?.backgroundColor || '';
    let textColor = btn.style?.textColor || '';

    if (
      (btn.componentId === 'center-actionButton' && btn.displayName === 'Done') ||
      (btn.fieldName === 'nextButton' && btn.fieldType === 'nextButton')
    ) {
      bgColor = '#009CFF';
      textColor = '#FFFFFF';
    } else if (isPrimary) {
      bgColor = '#2563EB';
    } else if (
      btn.componentId === 'clearButton' ||
      btn.clickAction === 'clearAll' ||
      btn.componentId === 'cancelButton' ||
      btn.componentId === 'previousButton' ||
      btn.clickAction === 'modalClose' ||
      btn.clickAction === 'goToPreviousStep'
    ) {
      bgColor = '#EAF4FF';
      textColor = '#009CFF';
    }

    if (this.isDarkMode()) {
      if (
        (btn.componentId === 'clearButton' ||
          btn.clickAction === 'clearAll' ||
          btn.componentId === 'cancelButton' ||
          btn.componentId === 'previousButton' ||
          btn.clickAction === 'modalClose' ||
          btn.clickAction === 'goToPreviousStep') &&
        !isPrimary
      ) {
        bgColor = '#23252e';
        textColor = '#99a1b7';
      }
    }

    return {
      'background-color': bgColor,
      color: textColor,
      'border-radius': btn.style?.borderRadius || '',
      'font-weight': btn.style?.fontWeight || '',
      padding: '8px 12px',
      'font-size': '12px',
      border: btn.style?.border || '',
    };
  }

  isSubmitButton(btn: any): boolean {
    return !this.isNonSubmitAction(btn);
  }
}
